var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-mux-wrapper"},[_c('video',{ref:"muxVideoPlayer",staticClass:"mux-video-js",attrs:{"controls":_vm.controls,"id":`${_vm.playerId}`}}),(_vm.loading)?_c('span',{staticClass:"align-middle spinner-border",attrs:{"aria-hidden":"true"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }